export type EventCapacity = {
  seats: number;
  registered: number;
  seatsRemaining?: number;
};

/** Prefer canonical ticket inventory (including active holds) when the server provides it. */
export function getEventSeatsRemaining(event: EventCapacity, registeredCount = event.registered): number {
  return Math.max(0, event.seatsRemaining ?? event.seats - registeredCount);
}
